// extracted by mini-css-extract-plugin
module.exports = {"estimate":"Estimate_estimate__o252I"};